import { render, staticRenderFns } from "./changePassword.vue?vue&type=template&id=6e2cc6a3"
import script from "./changePassword.vue?vue&type=script&lang=js"
export * from "./changePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports